import { useState, useEffect } from 'react';
import { crewsAPI } from '../../services/api';

export const useExperimentalCrews = (trainingGroupId) => {
  const [experimentalCrews, setExperimentalCrews] = useState([]);
  const [loadingExperimentalCrews, setLoadingExperimentalCrews] = useState(false);

  useEffect(() => {
    const loadExperimentalCrews = async () => {
      if (!trainingGroupId) {
        setExperimentalCrews([]);
        setLoadingExperimentalCrews(false);
        return;
      }

      setLoadingExperimentalCrews(true);

      try {
        const crews = await crewsAPI.getCrews({
          experimental_only: true,
          training_group_id: trainingGroupId,
        });
        setExperimentalCrews(crews);
      } catch (error) {
        console.error('Error loading experimental crews:', error);
        setExperimentalCrews([]);
      } finally {
        setLoadingExperimentalCrews(false);
      }
    };

    loadExperimentalCrews();
  }, [trainingGroupId]);

  const shouldSkipLockedSeatings = () => {
    if (!trainingGroupId) {
      return false;
    }
    if (loadingExperimentalCrews) {
      return false;
    }
    return experimentalCrews.length === 0;
  };

  return {
    experimentalCrews,
    loadingExperimentalCrews,
    shouldSkipLockedSeatings,
  };
};
